module.exports = __webpack_public_path__ + "img/simon-plan-logo.8aebc748.svg";